<template>
  <div class="slider-container">
    <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide 
            v-for="(row, index) in sliders" 
            :key="index"
            :data-swiper-autoplay="row.duration + '000'">
            
            <div class="slide-header">
            <img class="slide-view" :src="row.file" alt="" />
            <div class="widget">
              <div class="container-fluid">
                <div class="widget-content align-items-center">
                  <div class="wid-title">
                    <div class="bg-title" 
                      :style="{borderBottom: `5px solid ${row.lineColor} !important`}" v-html="row.title">
                    </div>
                  </div>
                  <div class="wid-tt">
                    <div class="wid-tt-flex">
                      <div class="title" v-html="row.subTitle"></div>
                      <div class="text" v-html="row.body"></div>
                    </div>
                    <div>
                      <router-link 
                        v-if="row.redirect" 
                        :to="row.redirect" 
                        class="nl-btn" 
                        v-html="row.button"></router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="gradient-easing"></div>
          </div>
        </swiper-slide>
    </swiper>

    <!-- <swiper-slide :data-swiper-autoplay="duration + '000'">
      <div class="slide-header">
        <img class="slide-view" :src="require('../../assets/gith/slider-2.png')" alt="" />
        <div class="widget">
          <div class="container-fluid">
            <div class="widget-content align-items-center">
              <div class="wid-title">
                <div class="bg-title" :style="{borderBottom: `5px solid ${'#26CBBE'}`}">Accreditation</div>
              </div>
              <div class="wid-tt">
                <div class="wid-tt-flex">
                  <div class="title white-color" v-html="'Become An Accredited Training Center '"></div>
                  <div class="text white-color" v-html="'Global Institutes of Tourism and Hospitality (GITH) is One of the world’s<br /> premier  of thinking since our 1998 founding.'">test</div>
                </div>
                <div>
                  <router-link to="/" class="nl-btn" v-html="'Read More'"></router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gradient-easing"></div>
      </div>
  </swiper-slide> -->
    
    <div class="bar-right">
      <div class="socialmedia-bar">
        <a v-for="(social, index) in rows" 
          class="facebook-icon social-icon" 
          :href="social.provider_url"
          target="_blank"
          :key="index">
          <i v-if="social.provider.toLowerCase() == 'facebook'"
            class="fab fa-facebook-f"></i>
          <i v-if="social.provider.toLowerCase() == 'youtube'"
            class="fab fa-youtube"></i>
          <i v-if="social.provider.toLowerCase() == 'linkedin'"
            class="fab fa-linkedin-in"></i>
          <i v-if="social.provider.toLowerCase() == 'twitter'"
            class="fab fa-twitter"></i>
        </a>
      </div>

      <div class="swiper-arrows">
        <button class="arr-btn" @click="prev">
          <span class="icon-arrow-left"></span>
        </button>
        <button class="arr-btn" @click="next">
          <span class="icon-arrow-right"></span>
        </button>
      </div>
    </div>

    <div class="swiper-pagination" slot="pagination"></div>

  </div>
</template>

<style scoped>
.swiper-container {
  height: 100vh;
  min-height: 500px;
  position: relative;
}
.slide-view {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}
.slide-header {
  height: 100%;
  background-size: cover;
}
.widget {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 20;
}
.gradient-easing {
  height: 400px !important;
  position: absolute;
  width: 100%;
  background-image: linear-gradient(transparent,rgba(0,0,0,.00709) 10.47%,rgba(0,0,0,.02755) 19.56%,rgba(0,0,0,.06016) 27.58%,rgba(0,0,0,.1037) 34.81%,rgba(0,0,0,.15697) 41.57%,rgba(0,0,0,.21875) 48.13%,rgba(0,0,0,.28782) 54.79%,rgba(0,0,0,.36296) 61.85%,rgba(0,0,0,.44297) 69.61%,rgba(0,0,0,.52662) 78.36%,rgba(0,0,0,.6127) 88.39%,rgba(0,0,0,.7));
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
}
.widget-content {
  border-top: 2px solid #fff;
  display: flex;
}
.wid-title {
  min-width: 345px;
  display: block;
  padding: 32px 25px 32px 0;
  border-right: 2px solid #fff;
}
.bg-title {
  color: #fff;
  display: inline-block;
  font-size: 40px;
  text-transform: uppercase;
  padding-bottom: 7px;
}
.wid-tt {
  width: 100%;
  padding: 13px 0 13px 30px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.top-line {
  height: 5px;
  width: 80px;
  margin-bottom: 13px;
}
.explore-btn {
  color: #fff;
  font-size: 18px;
  border: 1px solid #fff;
  padding: 5px 18px;
  line-height: 1;
  display: inline-block;
}
.explore-btn:hover {
  background: #fff;
  color: #000;
}
.explore-btn:active {
  opacity: 0.6;
}
.swiper-arrows {
  line-height: 1;
}
.arr-btn {
  color: #fff;
  font-size: 27px;
  display: block;
  transform: rotate(90deg);
  margin-bottom: 15px;
}
.arr-btn:hover {
  color: #ddd;
}
.arr-btn:active {
  opacity: 0.6;
}
.bar-right {
  position: absolute;
  right: 50px;
  bottom: 200px;
  z-index: 20;
  text-align: center;
}
.title {
  line-height: 1;
}
.bar-right a {
  display: block;
  margin-bottom: 12px;
}
.socialmedia-bar {
  margin-bottom: 20px;
}
.bar-right a i {
  color: #fff;
  font-size: 18px;
}
.bar-right a:hover {
  color: #ccc;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  .swiper-container {
    /* height: auto; */
    /* min-height: auto; */
  }
  .slide-header {
    padding: 100px 20px 95px;
    background-position: center;
  }
  .bg-title {
    font-size: 35px;
  }
  .widget-content {
    display: block;
    border-top: none
  }
  .wid-title {
    /* padding: 20px 0; */
    padding: 20px 0 0;
    border-right: none;
    /* border-bottom: 2px solid #fff; */
  }
  .wid-tt {
    padding: 13px 0;
    min-width: auto;
  }
  .bar-right {
    right: 15px;
    top: 160px;
    bottom: auto;
  }
  .socialmedia-bar {
    margin-bottom: 20px;
  }
  .wid-tt {
    display: block;
  }
  .title {
    margin-bottom: 12px;
  }
  .text {
    margin-bottom: 16px;
  }
  .widget {
    bottom: 50px
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .bg-title {
    font-size: 40px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .swiper-container {
    /* height: calc(100vh - 91.45px); */
    /* min-height: auto; */
  }
  .slide-header {
    padding: 100px 20px 95px;
    background-position: center;
  }
  .bg-title {
    font-size: 35px;
  }
  .widget-content {
    display: block;
    border-top: none
  }
  .wid-title {
    /* padding: 20px 0; */
    padding: 20px 0 0;
    border-right: none;
    /* border-bottom: 2px solid #fff; */
  }
  .wid-tt {
    padding: 13px 0;
    min-width: auto;
  }
  .bar-right {
    right: 50px;
    top: 250px;
    bottom: auto;
  }
  .socialmedia-bar {
    margin-bottom: 20px;
  }
  .wid-tt {
    display: block;
  }
  .title {
    margin-bottom: 12px;
  }
  .text {
    margin-bottom: 16px;
  }
  .widget {
    bottom: 50px
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .slide-header {
    padding: 100px 20px 95px;
    background-position: center;
  }
  .bg-title {
    font-size: 35px;
  }
  .widget-content {
    display: block;
    border-top: none
  }
  .wid-title {
    /* padding: 20px 0; */
    padding: 20px 0 0;
    border-right: none;
    /* border-bottom: 2px solid #fff; */
  }
  .wid-tt {
    padding: 13px 0;
    min-width: auto;
  }
  .bar-right {
    right: 50px;
    top: 250px;
    bottom: auto;
  }
  .socialmedia-bar {
    margin-bottom: 20px;
  }
  .wid-tt {
    display: block;
  }
  .title {
    margin-bottom: 12px;
  }
  .text {
    margin-bottom: 16px;
  }
  .widget {
    bottom: 80px
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .title {
    margin-bottom: 7px;
  }
}
</style>

<script>
// Very Important npm install swiper@5.4.5 
import axios from 'axios';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: "Slider",
//   props: ['row'],
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  
  data() {
    return {
      pgLoading: true,
      duration: 4,
      rows: [],
      sliders: [],
      swiperOptions: {
        direction: 'vertical',
        loop: false,
        speed: 1000,
        mousewheel: true,
        autoplay: {
            
          // delay: 4000, or data-swiper-autoplay="2000" in html
        },
        spaceBetween: 4,
        // slidesPerView: 3,
        navigation: {
            nextEl: '.swiperNext',
            prevEl: '.swiperPrev'
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        },
      }
    };
  },
  created() {
    this.fetchSlider();
    axios
      .get(window.baseURL + "/setting")
      .then((res) => {
        this.rows = res.data.social;
        this.header = res.data.header;
      })
      .catch(() => { });
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    prev() {
        this.$refs.mySwiper.$swiper.slidePrev();
    },
    next() {
        this.$refs.mySwiper.$swiper.slideNext();
    },
    fetchSlider() {
      axios
        .get(window.baseURL + "/sliders")
        .then((res) => {
          this.pgLoading = false;
          this.sliders = res.data.rows;
        })
        .catch(() => {});
    },
  },
};
</script>
